<div nz-col class="bg-white px-md">
  <div class="alain-default__content-title" style="height: 44px">
    <span style="color: black" class="font-weight-bold">{{ listTitle }}</span>
  </div>
  <nz-form-item *ngIf="type === 1">
    <nz-form-control class="mr-xs" style="width: 155px">
      <nz-input-group nzSearch [nzAddOnAfter]="suffixIconButton">
        <input type="text" nz-input placeholder="请输入账号或姓名" [(ngModel)]="wwx_chat_user" />
      </nz-input-group>
      <ng-template #suffixIconButton>
        <button nz-button nzType="default" (click)="seach()"><span nz-icon nzType="search"></span></button>
      </ng-template>
    </nz-form-control>
  </nz-form-item>
  <nz-form-item *ngIf="type === 2">
    <nz-form-control class="mr-xs">
      <nz-input-group nzSearch [nzAddOnAfter]="suffixIconButton">
        <input type="text" [(ngModel)]="wwx_chat_customer" nz-input placeholder="请输入昵称" style="width: 260px" />
      </nz-input-group>
      <ng-template #suffixIconButton>
        <button nz-button (click)="seach()" nzType="default"><span nz-icon nzType="search"></span></button>
      </ng-template>
    </nz-form-control>
  </nz-form-item>
  <div class="overflow-auto" style="height: calc(100vh - 275px)">
    <nz-spin [nzSpinning]="loading">
      <nz-empty *ngIf="showData.length == 0" nzNotFoundImage="simple"></nz-empty>
      <div
        *ngFor="let item of showData; let i = index"
        [class]="itemClassName(item, item.id)"
        (click)="selectItem(item, item.id)"
        style="height: 64px; padding-top: 10px; padding-left: 5px"
        class="list-hover"
      >
        <div nz-row nzAlign="middle">
          <div nz-col nzFlex="60px">
            <div *ngIf="type === 1">
              <nz-avatar
                [nzSize]="45"
                [nzSrc]="item.img_head_url"
                [nzText]="item.avatar_name"
                style="color: #2db7f5; background-color: #2db7f51a"
              ></nz-avatar>
            </div>
            <div *ngIf="type === 2">
              <nz-avatar
                [nzSrc]="item.img_head"
                [nzText]="item.avatar_name"
                style="color: #f56a00; background-color: #fde3cf"
                [nzSize]="45"
              ></nz-avatar>
            </div>
          </div>
          <div nz-col nzFlex="auto">
            <div *ngIf="type === 1">
              <div style="color: #222222; max-width: 150px" [title]="item.real_name" class="text-truncate"> {{ item.real_name }}</div>
              <div style="color: #999999; max-width: 150px" [title]="item.account" class="text-truncate">
                账号:{{ item.account || '-' }}</div
              >
            </div>
            <div *ngIf="type === 2">
              <div style="color: #222222" [title]="item.name" class="d-flex align-items-center justify-content-between">
                <span class="d-flex"
                  ><span class="text-truncate" style="max-width: 64px">{{ item.name }}</span>
                  <span class="font-weight-bold text-success" *ngIf="item.wwx_type == 1"
                    >{{ '@' }} {{ item.wwx_type == 1 ? '微信' : '-' }}</span
                  >
                  <span class="font-weight-bold text-success" *ngIf="item.wwx_type == 2"
                    >{{ '@' }} {{ item.wwx_type == 2 ? '企业微信' : '-' }}</span
                  ></span
                >
                <span class="text-xs" style="color: #746b6b">{{ item.last_chat_time * 1000 | date: 'yyyy-MM-dd HH:mm:ss' }}</span>
              </div>
              <div style="color: #7a7575; max-width: 180px" [title]="item.wwx_account" class="text-truncate"
                >{{ item.wwx_account || '-' }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </nz-spin>
  </div>
  <div class="text-center mt-sm" style="height: 30px"
    ><nz-pagination
      [nzPageIndex]="page.p"
      [nzTotal]="page.count"
      nzSimple
      (nzPageIndexChange)="onPageIndexChange($event)"
      [nzHideOnSinglePage]="true"
    ></nz-pagination
  ></div>
</div>
